import { useState } from "react";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { USER_HAS_PERSONAL_BANK_ACCOUNT } from "graphql/account";

/**
 * Personal-bank-account nudge for the reimbursement flow: a missing account is
 * a non-blocking banner, since the payout simply waits until one is connected.
 * `closeDrawer` re-checks the account so the banner clears once one is added.
 */
export function usePersonalBankAccountNudge(
  payToId: string | undefined,
  payingSelf: boolean,
) {
  const { t } = useTranslation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const { data, refetch } = useQuery(USER_HAS_PERSONAL_BANK_ACCOUNT, {
    variables: { userId: payToId },
    skip: !payToId,
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });

  const missing = !!payToId && !!data && !data.userHasPersonalBankAccount;

  return {
    message: missing
      ? t(
          payingSelf
            ? "ReimbursementBankAccountBanner"
            : "PersonalBankAccountErrorMessage",
        )
      : null,
    isDrawerOpen,
    openDrawer: () => setIsDrawerOpen(true),
    closeDrawer: () => {
      setIsDrawerOpen(false);
      refetch();
    },
  };
}
